/* How a map size is worded (requirement 35, M12). The sizes themselves — which exist and how many
   crowns each gives — are the server's (`map_sizes` in GET /game-config/, `selectMapSizes`); this
   only names them, in the player's language. */

import i18n from "src/i18n"
import { mapSizeOf } from "src/utils/world"

// "Small", "Medium", "Large".
export const mapSizeName = (size) => i18n.t(`lobby.mapSize.${mapSizeOf(size)}`)

// "Small map": the label a lobby header, a live-game row and a history row carry.
export const mapLabel = (size) => i18n.t(`lobby.mapSize.map_${mapSizeOf(size)}`)

// "Small — 1 crown": one row of `selectMapSizes`, as the create and find dialogs offer it.
export const mapSizeOptionLabel = ({ size, crowns }) =>
  i18n.t("lobby.mapSize.option", { name: mapSizeName(size), count: crowns })

/* How many of the three starting cities are crowns on `size`, off the published table. A server
   that publishes none plays every game on L, where every starting city is a crown — which is the
   `fallback` the caller passes (the number of starting cities). */
export const crownsOn = (mapSizes, size, fallback) =>
  (mapSizes || []).find((row) => row.size === mapSizeOf(size))?.crowns ?? fallback
